let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eSeoX")).then(() => parcelRequire('lSFnn'));